<script setup lang="ts">
import { THEME } from '@pkg/config/misc/theme';
import type { PrivacyBlockControlLabels } from '@pkg/types/privacyControls';
import type { PortableTextTextBlock } from '@sanity/types';
import { computed, type Component } from 'vue';

const props = defineProps<{
  block?: {
    _type: string;
    _key: string;
    theme?: THEME;
    anchorId?: string;
    preTitle?: string;
    title?: string;
    description?: Array<PortableTextTextBlock>;
    controlLabels?: PrivacyBlockControlLabels;
    contentAlignment?: 'left' | 'center';
  };
  config: {
    innerComponent?: Component;
  };
}>();

const data = computed(() => ({
  theme: props.block?.theme ?? THEME.DARK,
  anchor: props.block?.anchorId,
  preTitle: props.block?.preTitle,
  title: props.block?.title,
  description: props.block?.description,
  controlLabels: props.block?.controlLabels,
  contentAlignment: props.block?.contentAlignment ,
}));
</script>

<template>
  <component :is="props.config?.innerComponent" v-bind="data" />
</template>
